import { useRouter } from "next/router";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Progress } from "antd";
import {
  fetchCity,
  fetchSliders,
  unfollowCity,
  followCity,
  showAppModal,
  fetchCityFollowers,
  fetchCityGroups,
} from "redux/actions/app";
import { fetchCityPostList, checkPostFlags } from "redux/actions/post";
import { getUserInfo } from "redux/actions/user";

// views
import Link from "next/link";
import SiteLayout from "components/layout/SiteLayout";
import Pager from "components/site/Pager";
import WechatGroupCard from "components/site/WechatGroupCard";
import PostSortDropdown from "components/post/PostSortDropdown";
import PostListItem from "components/post/PostListItem";
import EmptyList from "components/app/EmptyList";
import Loading from "components/app/Loading";
import CitySwiper from "./CitySwiper";
import RelatedGroupsCard from "~/components/sider/RelatedGroupsCard";
import CityOwnerCard from "./CityOwnerCard";
import CityRulesCard from "components/cities/CityRulesCard";
import CityMembersCard from "components/cities/CityMembersCard";
import CityTags from "components/cities/CityTags";
import CityPromoList from "components/cities/CityPromoList";
import CityJoinBtn from "./CityJoinBtn";

import Error from "pages/_error";

// Import city index icons
import cloudIcon from "~/public/static/icons/cloud.png";
import sightIcon from "~/public/static/icons/sight.png";
import foodIcon from "~/public/static/icons/food.png";
import priceIcon from "~/public/static/icons/price.png";
import happyIcon from "~/public/static/icons/happy.png";
import commonIcon from "~/public/static/icons/common.png";

import _ from "lodash";
import { getCookie } from "utils/cookie";
import { useEffect, useState } from "react";
import UserAvatar from "components/user/UserAvatar";
import moment from "moment";
import { userUrl } from "utils/route";
import { isMobile } from "react-device-detect";

const Page = ({
  postList,
  sliders,
  city: cityPro,
  sort: pageSort,
  user,
}: any) => {
  const router = useRouter();
  const query = router.query;
  const sort = query.sort || pageSort;
  const kind = query.kind;
  const [city, setCity] = useState(cityPro);
  const [members, setMembers] = useState<any>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [groups, setGroups] = useState<any>([]);

  if (!city) {
    return <Error statusCode="404" />;
  }

  const [isClientMobile, setIsClientMobile] = useState(false);

  useEffect(() => {
    setIsClientMobile(isMobile);
  }, []);

  const pageSider = (
    <>
      {!isClientMobile && <CityOwnerCard city={city} />}
      <CityRulesCard />
      {!isClientMobile && <CityMembersCard city={city} />}
      {groups.length > 0 && <RelatedGroupsCard groups={groups} />}
      <WechatGroupCard />
      <CityPromoList city={city} />
    </>
  );

  const indexes: any = {
    "气候&空气": cloudIcon,
    自然风光: sightIcon,
    吃货友好: foodIcon,
    房价物价: priceIcon,
    社交氛围: happyIcon,
    同类指数: commonIcon,
  };

  const pageHeader = (
    <div className="city-details-wrapper">
      <CitySwiper images={sliders} />
      <div className="city-details">
        <div className="top">
          <div className="city-name">{city.name}</div>
          <CityTags
            city={city}
            className="hide-in-mp"
          />
        </div>
        <div className="bottom">
          {Object.entries(city.indexes).map(([indexName, indexValue]: any) => (
            <div
              key={indexName}
              className="index"
            >
              <img
                src={
                  indexes[indexName] ? indexes[indexName].src : commonIcon.src
                }
              />
              <div>
                <div className="text">{indexName}</div>
                <Progress
                  showInfo={false}
                  percent={indexValue / 0.05}
                  steps={5}
                  strokeColor={
                    indexValue >= 4
                      ? "#45D05C"
                      : indexValue >= 3
                        ? "#f9ba48"
                        : "#F97D48"
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const fetchFollowers = () => {
    fetchCityFollowers(city.id, 1, 9).then((res) => {
      setMembers(res.followers);
      setTotalCount(res.pager.total_count);
    });
  };

  const fetchCities = () => fetchCityGroups(city.id).then(setGroups);

  useEffect(() => {
    fetchFollowers();
    fetchCities();
  }, []);

  return (
    <SiteLayout
      pageTitle={city.name}
      pageHeader={sliders.length > 0 && pageHeader}
      pageSider={pageSider}
    >
      <div className="owner-wrapper">
        <div className="owner-info">
          <div className="left">
            <UserAvatar
              user={city.owner}
              size={28}
            />
            <Link
              legacyBehavior
              key={user ? user.id : city.owner.id}
              href="/users/[id]"
              as={userUrl(city.owner, user)}
            >
              <a target="_blank">
                <div className="nickname">{city.owner.nickname}</div>
              </a>
            </Link>
            <div className="create-time">
              {moment(city.created_at).format("YYYY.MM.DD")}创建
            </div>
          </div>
          <CityJoinBtn
            city={city}
            refresh={() => fetchFollowers()}
          />
        </div>
        <div className="line"></div>
        <CityTags city={city} />
        <div className="members-wrapper">
          {members.slice(0, 8).map((user: any) => (
            <UserAvatar
              key={user.id}
              size={24}
              user={user}
            />
          ))}
          {members.length > 8 && <div className="more-users"></div>}
          <div className="total-count">
            <span>{totalCount}</span>个居民
          </div>
        </div>
      </div>

      <div className="city-menu-wrapper">
        <Link
          legacyBehavior
          href={`/cities/${city.id}`}
        >
          <a>
            <div className={!kind ? "active" : ""}>全部</div>
          </a>
        </Link>
        <Link
          legacyBehavior
          href={`/cities/${city.id}?kind=life`}
        >
          <a>
            <div className={kind && kind === "life" ? "active" : ""}>生活</div>
          </a>
        </Link>
        <Link
          legacyBehavior
          href={`/cities/${city.id}?kind=job`}
        >
          <a>
            <div className={kind && kind === "job" ? "active" : ""}>工作</div>
          </a>
        </Link>
        <Link
          legacyBehavior
          href={`/cities/${city.id}?kind=space`}
        >
          <a>
            <div className={kind && kind === "space" ? "active" : ""}>据点</div>
          </a>
        </Link>
      </div>

      <Card>
        <div
          className="mb-20"
          style={{ lineHeight: "30px" }}
        >
          <span>
            共 {postList.pager ? postList.pager.total_count : 0} 个帖子
          </span>
          <span className="pull-right">
            <PostSortDropdown
              localization
              sort={sort}
            />
          </span>
        </div>

        <div style={{ borderBottom: "1px solid #f7f7f7" }} />

        <div className={`post-list ${query.category ? "bordered" : ""}`}>
          {postList ? (
            postList.posts.length ? (
              postList.posts.map((post: any) => (
                <PostListItem
                  post={post}
                  key={post.id}
                />
              ))
            ) : (
              <EmptyList />
            )
          ) : (
            <Loading />
          )}
        </div>

        <Pager
          pager={postList && postList.pager}
          onPageChange={() => {}}
        />
      </Card>

      <style jsx>
        {`
          .post-list.bordered {
            border-top: 1px solid #f7f7f7;
          }
        `}
      </style>
    </SiteLayout>
  );
};
const mapStateToProps = (state: any) => ({
  user: state.user.user,
  flags: state.post.flags,
  followedCities: state.app.followedCities,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      checkPostFlags,
      getUserInfo,
      unfollowCity,
      followCity,
      showAppModal,
    },
    dispatch
  );

Page.getInitialProps = async (ctx: any) => {
  const { query }: any = ctx;

  const cookieSort = getCookie("sort", ctx.req);

  let postList, sliders, city;
  try {
    city = await fetchCity(query.id);
    if (city) {
      postList = await fetchCityPostList({
        sort: query.sort || cookieSort,
        kind: query.kind,
        city_id: query.id,
        page: parseInt(query.page) || 1,
      });
      sliders = await fetchSliders({
        kind: "city",
        listed: "",
        city_id: query.id,
      });
    }
  } catch (error: any) {
    ctx.res.statusCode = error.statusCode;
  }

  return {
    postList,
    sliders,
    city,
    sort: cookieSort,
  } as any;
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
